var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-simple-table',{staticClass:"rounded-lg"},[_c('thead',[_vm._t("thead")],2),_c('draggable',{attrs:{"value":_vm.value,"tag":"tbody","draggable":!_vm.isXs?'.draggable':''},on:{"input":_vm.emit,"start":function($event){_vm.drag=true},"end":function($event){_vm.drag=false}}},[_vm._t("tbody")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }